import React, { Component } from "react";
import { HashRouter as Router, Route } from "react-router-dom";
import Footer from "./components/Footer";
import DecisionAid from "./components/DecisionAid";

class App extends Component {
  render() {
    return (
      <div id="page-container">
        <div id="content-wrap">
          <Router>
            <Route
              path="/:projectId/:documentId/:timestamp"
              component={DecisionAid}
            />
          </Router>
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;
